import { render, staticRenderFns } from "./BowCTABlock.vue?vue&type=template&id=07e8a943&"
import script from "./BowCTABlock.vue?vue&type=script&lang=js&"
export * from "./BowCTABlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowAnimation: require('/workspace/components/base/BowAnimation/BowAnimation.vue').default,BowCallToAction: require('/workspace/components/molecules/BowCallToAction/BowCallToAction.vue').default})
